export default [
    {
        type: "uni",
        id: 1,
        items: [
            {
                id: 1,
                text: "Die Vortragenden waren engagiert und motiviert.",
            },
            {
                id: 2,
                text: "Die Vortragenden haben die Inhalte angemessen präsentiert.",
            },
            {
                id: 3,
                text: "Ich konnte dem Tempo der Vortragenden gut folgen.",
            },
            {
                id: 4,
                text: "Die Vortragenden gaben ausreichend Gelegenheit zur Diskussion.",
            },
            {
                id: 5,
                text: "Die Vortragenden haben die Inhalte interessant vermittelt.",
            },
            {
                id: 6,
                text: "Das von den Vortragenden zur Verfügung gestellte Material bzw. die eingesetzten Medien waren hilfreich.",
            },
            {
                id: 7,
                text: "Die Vortragenden ermöglichten eine produktive Diskussionsatmosphäre.",
            },
            {
                id: 8,
                text: "Die inhaltliche Konzeption der Ringvorlesung wurde mir deutlich.",
            },
            {
                id: 9,
                text: "Die inhaltliche Konzeption wurde von vornherein gut definiert.",
            },
            {
                id: 10,
                text: "Die Ringvorlesung war übersichtlich und verständlich.",
            },
            {
                id: 11,
                text: "Ich konnte auch den für mich fachfremden Vorträgen gut folgen.",
            },
            {
                id: 12,
                text: "Ich habe in der Ringvorlesung Wichtiges gelernt.",
            },
            {
                id: 13,
                text: "Ich habe in der Ringvorlesung wichtige Kompetenzen weiterentwickelt.",
            },
            {
                id: 14,
                text: "Die vermittelten Kompetenzen sind für meine wissenschftliche Entwicklung relevant.",
            },
            {
                id: 15,
                text: "Das behandelte Thema enthält Bezüge zu meiner aktuellen Forschungstätigkeit.",
            },
            {
                id: 16,
                text: "Die Schwierigkeit des Stoffes war angemessen.",
            },
            {
                id: 17,
                text: "Der Umfang des Stoffes war angemessen.",
            },
            {
                id: 18,
                text: "Das Tempo der Ringvorlesung war angemessen.",
            },
            {
                id: 19,
                text: "Die Anforderungen der Ringvorlesung waren angemessen.",
            },
            {
                id: 20,
                text: "Der Zeitaufwand für die Ringvorlesung insgesamt (inkl. Vor- und Nachbereitung) war angemessen.",
            },
            {
                id: 21,
                text: "Insgesamt hat mich die Ringvorlesung überfordert.",
            },
            {
                id: 22,
                text: "Ich habe aus eigener Initiative Literatur zum Stoff der Ringvorlesung gelesen.",
            },
            {
                id: 23,
                text: "Ich habe mich aktiv in die Ringvorlesung eingebracht.",
            },
            {
                id: 24,
                text: "Ich habe viel Zeit in die Vor- und Nachbereitung der Ringvorlesung investiert.",
            },
            {
                id: 25,
                text: "Insgesamt fand ich die Ringvorlesung gut.",
            },
            {
                id: 26,
                text: "In der Ringvorlesung habe ich viel gelernt.",
            },
            {
                id: 27,
                text: "Meine Erwartungen an die Ringvorlesung wurden erfüllt.",
            },
        ],
    },
    {
        type: "text",
        id: 2,
        items: [
            {
                id: 28,
                text: "Folgendes hat mir an der Ringvorlesung besonders gefallen",
            },
            {
                id: 29,
                text: "Folgendes hat mir an der Ringvorlesung nicht gefallen/Ich habe folgende Verbesserungsvorschläge zur Ringvorlesung",
            },
            {
                id: 30,
                text: "Ich hätte mir mehr wissenschaftlichen Input zu folgenden Bereichen gewünscht",
            },
        ],
    },
];